export const normalizeObserver = (type, callback, options) => {
    let observer;
    let observeFunc;
    switch (type) {
        case MutationObserver:
        case ResizeObserver:
            observer = new type(callback);
            observeFunc = ((target) => observer.observe(target, options));
            break;
        case IntersectionObserver:
            observer = new type(callback, options);
            observeFunc = ((target) => observer.observe(target));
            break;
        case PerformanceObserver:
            observer = new type(callback);
            observeFunc = (() => observer.observe(options));
            break;
    }
    return [observer, observeFunc];
};
export class Observers {
    constructor() {
        this.inner = new Map();
    }
    add(target, type, callback, options) {
        const [observer, observeFunc] = normalizeObserver(type, callback, options);
        if (!observer) {
            return;
        }
        this.inner.set(observer, (this.inner.get(observer) || new Set()).add(target));
        observeFunc(target);
        return observer;
    }
    remove(ob, target) {
        ob.disconnect();
        const set = this.inner.get(ob);
        if ("unobserve" in ob) {
            if (target) {
                ob.unobserve(target);
                set?.delete(target);
            }
            else {
                set?.forEach((target) => {
                    ob.unobserve(target);
                });
                set?.clear();
            }
            if (set && !set.size) {
                this.inner.delete(ob);
            }
        }
        else if (set) {
            this.inner.delete(ob);
        }
    }
    removeAll() {
        this.inner.forEach((_, ob) => {
            this.remove(ob);
        });
    }
}
//# sourceMappingURL=observers.js.map